import PiadaOneApi from './PiadaOneApi';
import { plainToClass } from 'class-transformer';
import { useUserStore } from '../stores/user';
import User from '../classes/User'
import BillingAccount from '../classes/BillingAccount';
import type ApiError from '../types/ApiError'
import RewardsProgram from '../classes/RewardsProgram';

export default {
  login(email: string, password: string, basket_id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = {
        emailaddress: email,
        password: password,
        basket_id: basket_id
      };

      PiadaOneApi.post(
        '/users/login',
        body,
        {
          // No need for custom headers here
        },
      ).then((response) => {
        let user = null as (User | null);
        if (response.status === 200 && response.data && (response.data.num == undefined || response.data.num == 200)) {
          user = plainToClass(User, (response.data as object), { excludeExtraneousValues: true }),
          resolve(user);
        } else {
          const error = {
            title: '',
            message: response.data.message,
            num: (response.data.num != undefined) ? response.data.num : 0
          } as ApiError;

          reject(error);
        }
      });
    });
  },
  fetchUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/users/me',
        {
          // headers: {
          //   "X-CSRF-Token": getCookie("CSRF-TOKEN")
          // },
        },
      ).then((response) => {
        let user = null as (User | null);
        if (response.status === 200 && response.data) {
          user = plainToClass(User, (response.data as object), { excludeExtraneousValues: true }),
          resolve(user);
        } else {
          reject(new Error('Could not find user'));
        }
      }).catch((error: Error) => {
          reject(error);
      });
    });
  },
  fetchBillingAccounts(): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/olo/users/user_auth/billingaccounts',
        {
          headers: {
            'X-User-Verify': 'url'
          },
        },
      ).then((response) => {
        let accts = [] as BillingAccount[];
        if (response.status === 200 && response.data) {
          const jsonObjs = response.data.billingaccounts;
          accts = jsonObjs.map(
            (acct: Object) => plainToClass(BillingAccount, (acct as object), { excludeExtraneousValues: true }),
          );
          resolve(accts);
        } else {
          reject(new Error('ERROR'));
        }
      });
    });
  },
  fetchRewards(): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/users/me/rewards',
        {
          headers: {
            'X-User-Verify': 'header'
          },
        },
      ).then((response) => {
        let rewards = [] as RewardsProgram[];
        if (response.status === 200 && response.data) {
          const jsonObjs = response.data.rewards_programs;
          rewards = jsonObjs.map(
            (rewardsProgram: Object) => plainToClass(RewardsProgram, (rewardsProgram as object), { excludeExtraneousValues: true }),
          );
          resolve(rewards);
        } else {
          reject(new Error('ERROR'));
        }
      });
    });
  },
};
